<div class="wrapper wrapper-content ng-scope animated fadeInRight">
  <div class="container-fluid ">
    <div class="row">
      <div class="col-12 col-md-3 help-file-list m-t-0">
        <ng-container *ngIf="helpModelFiles" class="info-element">
          <p-listbox [(options)]="helpModelFiles" [(ngModel)]="selectedHelpFile" (onChange)="selectFile($event.value)"
            [disabled]="isEditing() ? 'disabled' : null">
            <p-header>
              <!--i class="fa faq-question"></i--> {{'Help.fileList' | translate}}
            </p-header>
            <ng-template let-element let-i="index" pTemplate="item">
              <div class="d-md-flex justify-content-between">
                <span class="text-left">{{element.label}} </span>
                <button class="btn btn-light pt-0 pb-0 text-right" aria-expanded="false"
                  (click)="download(element.value)" title="{{'General.download' | translate}}" type="button">
                  <i class="fas fa-download" aria-hidden="true"></i> </button>
              </div>
            </ng-template>
            <p-footer>
              <div class="d-md-flex justify-content-between m-t-md">
                <button class="btn btn-secondary btn-sm  col-12 col-md-5 m-t-md" aria-expanded="false"
                  (click)="newHelpFile()" [attr.disabled]="isEditing() ? 'disabled' : null" type="button">
                  <i class="fas fa-plus" aria-hidden="true"></i> {{'General.add' | translate}} </button>
                <button class="btn btn-secondary btn-sm col-12 col-md-5 m-t-md" aria-expanded="false"
                  (click)="removeFile()" [attr.disabled]="
                            isEditing() && selectedHelpFile !== undefined ? 'disabled' : null
                          " type="button">
                  <i class="fas fa-times" aria-hidden="true"></i> {{'General.delete' | translate}} </button>
              </div>
              <!--div class="d-flex justify-content-between m-t-md">
                <button class="btn btn-secondary btn-sm  col-12" aria-expanded="false" (click)="download()"
                  [attr.disabled]="isEditing() ? 'disabled' : null">
                  <i class="fas fa-download" aria-hidden="true"></i> Descargar </button>
              </div-->
              <div class="d-flex justify-content-between m-t-md">
                <input type="file" (change)="onFileChange($event)" multiple="false" #fileImport />
                <button class="btn btn-secondary btn-sm  col-12" aria-expanded="false" (click)="openFileImportDialog()"
                  [attr.disabled]="isEditing() ? 'disabled' : null" type="button">
                  <i class="fas fa-upload" aria-hidden="true"></i> {{'General.upload'|translate}} </button>
              </div>
            </p-footer>
          </p-listbox>
        </ng-container>
      </div>
      <div class="col-12 col-md-9 m-t-0">
        <div class="col-12 m-t-md m-b-md titleElement" *ngIf="selectedHelpFile"> {{'Help.fileSelected' | translate}}
          {{selectedHelpFile.identifier||'none'}}</div>
        <!--div class="col-12" *ngIf="helpModelFiles;">
          <button class="btn btn-secondary m-r-sm float-left" aria-expanded="false" (click)="cancelEditing()" tabindex="-1" [attr.disabled]="!isEditing() ? 'disabled' : null"> <i class="fas fa-times"
                aria-hidden="true"></i> {{'General.cancel' | translate}} </button>
          <button class="btn btn-secondary m-r-sm float-right" aria-expanded="false" (click)="editMode()" [attr.visible]="!isEditing() ? 'true' : null" tabindex="-1">
            <i class="fas fa-pencil-alt" aria-hidden="true"></i> {{'General.edit' | translate}} </button>
          <button class="btn btn-primary m-r-sm float-right" aria-expanded="false" (click)="saveHelpFile()" [attr.disabled]="!isEditing() ? 'disabled' : null" tabindex="1">
            <i class="fas fa-save" aria-hidden="true"></i> {{'General.save' | translate}} </button>
        </div-->
        <div class="col-12" #formContainer></div>
      </div>
      <ng-template #noHelp> {{'Help.noHelp' | translate}}</ng-template>
    </div>
  </div>
</div>